<template>
  <div class="wrapper">
    <template v-if="checkbox">
      <input
        id="degraded-cdw"
        type="checkbox"
        v-model="cdw"
      >
      <label
        class="text"
        for="degraded-cdw"
        v-html="text"
      />
    </template>
    <div
      v-else
      class="text"
    >
      {{ text }}
    </div>
    <basic-prompt :position="{top: 'auto', bottom: 0, right: 0, left: 'auto'}">
      <template v-slot:visible>
        <svg class="info-icon">
          <use xlink:href="#icon-info"></use>
        </svg>
      </template>
      <template v-slot:prompt>
        <div v-html="info" />
      </template>
    </basic-prompt>
  </div>
</template>
<script>
import BasicPrompt from '../../../shared/BasicPrompt'

export default {
  name: 'DegradedModePrompt',
  components: {
    BasicPrompt,
  },
  props: {
    text: { type: String, required: true },
    info: { type: String, required: true },
    checkbox: { type: Boolean, required: false },
  },
  data() {
    return { cdw: false }
  },
  watch: {
    cdw: {
      handler(newVal) {
        this.$store.commit('quotation/SET_CDW', newVal)
      },
      immediate: true,
    },

  },
}
</script>
<style lang="scss" scoped>

.wrapper {
  align-items: center;
  display: flex;
  margin: 0 0 20px;
  padding: 0;
}

.text {
  color: black;
  font-size: 1.6rem;
  margin: 0 5px 0 0;
}

.info-icon {
  height: 16px;
  pointer-events: none;
  width: 16px;
}

input {
  display: none;
}

label {
  align-items: center;
  cursor: pointer;
  display: flex;
  position: relative;

  &::after,
  &::before {
    border: 2px solid black;
    content: '';
    display: block;
    height: 20px;
    width: 20px;
  }

  &::before {
    margin: 0 5px 0 0;
  }

  input:checked + &::before {
    background: $orange;
  }

  &::after {
    border: 3px solid white;
    border-right: none;
    border-top: none;
    content: '';
    display: none;
    height: 7px;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%) translate(5px, -2px) rotate(-45deg);
    width: 10px;
  }

  input:checked + &::after {
    display: block;
  }
}
</style>
